import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 13992 15822"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:229.303}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970272241152">
        <path
          d="M5467 369c-339 339-339 888 0 1227 338 339 888 339 1227 0s339-888 0-1227-888-339-1227 0zM7777 2678c-340 339-340 889 0 1227 338 339 888 339 1227 0s339-888 0-1227-889-339-1227 0zM10086 4988c-339 339-339 889 0 1227 339 339 888 339 1227 0 339-338 339-888 0-1227s-888-339-1227 0zM12396 7297c-339 339-339 888 0 1228 338 339 888 339 1227 0s339-889 0-1228c-339-338-889-338-1227 0zM5467 15453c-339-338-339-888 0-1227 338-339 888-339 1227 0s339 889 0 1227c-339 339-888 339-1227 0zM7777 13143c-340-338-340-888 0-1227 338-338 888-338 1227 0 339 339 339 889 0 1227-339 340-889 340-1227 0zM10086 10834c-339-339-339-888 0-1227s888-339 1227 0 339 888 0 1227-888 339-1227 0z"
          className="fill stroke1"
          style={{
            strokeWidth: 229.303,
          }}
        />
        <path
          d="M12396 8525c-339-339-339-889 0-1228 338-339 888-339 1227 0s339 888 0 1228c-339 338-889 338-1227 0z"
                    className="fill stroke1"
          style={{
            strokeWidth: 229.303,
          }}

        />
      </g>
      <g id="_1970272242208">
        <path
          d="M369 369c-339 339-339 888 0 1227s888 339 1227 0 339-888 0-1227-888-339-1227 0zM2678 2678c-338 339-338 889 0 1227 339 339 889 339 1228 0 338-339 338-888 0-1227-339-339-889-339-1228 0zM4988 4988c-339 339-339 889 0 1227 339 339 888 339 1227 0 339-338 339-888 0-1227s-888-339-1227 0zM7297 7297c-339 339-339 888 0 1228 339 339 889 339 1227 0 339-339 339-889 0-1228-338-338-888-338-1227 0zM369 15453c-339-338-339-888 0-1227s888-339 1227 0 339 889 0 1227c-339 339-888 339-1227 0zM2678 13143c-338-338-338-888 0-1227 339-338 889-338 1228 0 338 339 338 889 0 1227-339 340-889 340-1228 0zM4988 10834c-339-339-339-888 0-1227s888-339 1227 0 339 888 0 1227-888 339-1227 0z"
                    className="fill stroke1"
          style={{
            strokeWidth: 229.303,
          }}

        />
        <path
          d="M7297 8525c-339-339-339-889 0-1228s889-339 1227 0c339 339 339 888 0 1228-338 338-888 338-1227 0z"
                    className="fill stroke1"
          style={{
            strokeWidth: 229.303,
          }}

        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
